(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collapse"] && !Shopify.designMode) return;
  try {
    
  const collapseBoxes = document.querySelectorAll('[data-collapse-box]').forEach(box => {
    box.addEventListener('click', function() {
      box.classList.toggle('active');
    })
  })

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["featured-product"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('product-modal')) {
    customElements.define('product-modal', class ProductModal extends ModalDialog {
      constructor() {
        super();
      }

      hide() {
        super.hide();
      }

      show(opener) {
        super.show(opener);
        this.showActiveMedia();
      }

      showActiveMedia() {
        this.querySelectorAll(`[data-media-id]:not([data-media-id="${this.openedBy.getAttribute("data-media-id")}"])`).forEach((element) => {
            element.classList.remove('active');
          }
        )
        const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);
        const activeMediaTemplate = activeMedia.querySelector('template');
        const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
        activeMedia.classList.add('active');
        activeMedia.scrollIntoView();

        const container = this.querySelector('[role="document"]');
        container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

        if (activeMedia.nodeName == 'DEFERRED-MEDIA' && activeMediaContent && activeMediaContent.querySelector('.js-youtube'))
          activeMedia.loadContent();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.getElementById('shopify-section-header');
      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');
      this.inlineMenu = this.querySelector('.header__inline-menu');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.inlineMenu.classList.add('active');
      this.closeMenuDisclosure();
    }

    reveal() {
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
      this.inlineMenu.classList.remove('active');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('details-disclosure');
      this.disclosures.forEach(disclosure => disclosure.close());
    }
  }

  customElements.define('sticky-header', StickyHeader);

  function modalCouytryActions () {
    const modalCountry = document.querySelector('.js-modal-country')
    const overlay = document.querySelector('#menu-drawer__country-overlay')
    function toggleModal (e) {
      e.preventDefault()
      modalCountry.classList.toggle("active");
      overlay.classList.toggle("active");
    }
    const btnModalToggle = document.querySelectorAll('.js-toggle-country-modal').forEach((toggleButton) =>
      toggleButton.addEventListener('click', toggleModal)
    );
    overlay.onclick = toggleModal

    const modalCountryDesk = document.querySelector('.js-country-modal-desk')
    function toggleModalDesk (e) {
      e.preventDefault()
      modalCountryDesk.classList.toggle("active");
    }
    const btnModalDeskToggle = document.querySelectorAll('.js-toggle-country-modal-desk').forEach((toggleButton) =>

      toggleButton.addEventListener('click', toggleModalDesk)
    );


  }
  modalCouytryActions()


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["image-with-text"] && !Shopify.designMode) return;
  try {
    
  const getStartedButtons = document.querySelectorAll('[data-button]');
  let productTemporaryData = [];
  let ecoPackSellingPlans = {};

  const handleDeleteEcoPacks = async (products) => {
    const cartResponse = await fetchCart();
    const ecoPackCollectionProductIds = ecoPackCollectionItems.map((product) => product.id);
    const ecoPacksInCart = cartResponse.items.filter((product) => ecoPackCollectionProductIds.includes(product.product_id));
    let subscriptionCartAmountNewState = 0;

    if (Array.isArray(ecoPacksInCart) && ecoPacksInCart.length) {
      subscriptionCartAmountNewState = ecoPacksInCart.reduce((previousValue, currentValue) => {
       return previousValue.quantity + currentValue.quantity
      });
    } else {
      subscriptionCartAmountNewState = 0
    }

    const sellingPlanIndex = Number(subscriptionCartAmountNewState) > 12 ? 11 : (Number(subscriptionCartAmountNewState) ? Number(subscriptionCartAmountNewState) : 0);
    for (const ecoPackCartItem of ecoPackCollectionItems) {
      const variantId = ecoPackCartItem.variants[0].id;
      const sellingPlan = ecoPackCartItem.selling_plan_groups[0].selling_plans[sellingPlanIndex].id;
      ecoPackSellingPlans[variantId] = sellingPlan;
    }

    productTemporaryData = ecoPacksInCart;

    const updates = {};
    for (const product of products) {
        if (Array.isArray(product.variants) && product.variants.length) {
            updates[product.variants[0].id] = 0;
        } else {
            console.log("Unexpected error product variants is not array");
        };
    }

    const response = await updateCart(JSON.stringify({
        updates: updates
    }));
    return response;
  }

  const handleAddEcoPacks = async (products) => {
    const productVariantId = document.querySelector('[name="id"]').value;
    const isProductHaveSellingPlan = document.querySelector('[name=selling_plan]').value;
    const selectedProductInCart = products.filter((product) => product.variant_id === Number(productVariantId));
    const isProductExistInCart =  Array.isArray(selectedProductInCart) && selectedProductInCart.length;
    let body = [];
      if (!isProductExistInCart) {
      let bodyItem = {
        id: Number(productVariantId),
        quantity: 1
      }

      if (isProductHaveSellingPlan) {
        bodyItem.selling_plan =  Number(isProductHaveSellingPlan)
      }

      body = [
        bodyItem
      ]
    }

    for (const product of products) {
      const isProductCartDataExist = typeof product === 'object' && product !== null;
      const productCartVariantId = product.variant_id;
      if (!isProductCartDataExist) {
        continue;
      }

      let productInCartQuantity = product.quantity;
      let addToCartDataItem = {
        "id": productCartVariantId,
        "quantity": productCartVariantId === Number(productVariantId) ? productInCartQuantity += 1 : productInCartQuantity,
      };

      if (isProductHaveSellingPlan) {
        addToCartDataItem.selling_plan = productCartVariantId === Number(productVariantId) ? Number(isProductHaveSellingPlan) : ecoPackSellingPlans[productCartVariantId];
      };

      body = [
        ...body,
        addToCartDataItem,
      ];
  }

  await addToCart(JSON.stringify({
    items: body
  }));
  }


  for (const getStartedButton of getStartedButtons) {
    getStartedButton.addEventListener('click', async (e) => {
      e.preventDefault();
      await handleDeleteEcoPacks(ecoPackCollectionItems);
      await handleAddEcoPacks(productTemporaryData);
      cartDrawer.openDrawer(cartDrawer.getSelectorTrigger());
    })
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ingarden-plus"]) return;
  try {
    
  class ProductModal extends ModalDialog {
    constructor() {
      super();
    }

    hide() {
      super.hide();
    }

    show(opener) {
      super.show(opener);
      this.showActiveMedia();
    }

    showActiveMedia() {
      this.querySelectorAll(`[data-media-id]:not([data-media-id="${this.openedBy.getAttribute("data-media-id")}"])`).forEach((element) => {
          element.classList.remove('active');
        }
      )
      const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);
      const activeMediaTemplate = activeMedia.querySelector('template');
      const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
      activeMedia.classList.add('active');
      activeMedia.scrollIntoView();

      const container = this.querySelector('[role="document"]');
      container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

      if (activeMedia.nodeName == 'DEFERRED-MEDIA' && activeMediaContent && activeMediaContent.querySelector('.js-youtube'))
        activeMedia.loadContent();
    }
  }

  customElements.define('product-modal', ProductModal);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["instagram"] && !Shopify.designMode) return;
  try {
    
  class InstagramSlider extends HTMLElement {
    constructor() {
      super();
      this.target = this.querySelector("#insta-feed");
      this.slider = null;

      this.createObserver();
    }

    createObserver() {
      let observer = new MutationObserver((mutationsList, observer) => {
        for (const mutation of mutationsList) {
          if (mutation.type === "childList" && mutation.addedNodes[0]?.tagName === 'DIV') {
            if (window.vendors && window.vendors.includes('swiper')) {
              this.initSlider();
            } else {
              document.addEventListener('swiper.loaded', () => {
                this.initSlider();
              });
            }
            observer.disconnect();
          }
        }
      });

      observer.observe(this.target, { childList: true, subtree: true });
    }

    initSlider() {
      this.swiperWrapper = this.target.children[0];

      this.target.classList.add('swiper-container');
      this.swiperWrapper.classList.add('swiper-wrapper');
      this.target.querySelectorAll('.slide-page').forEach(el => el.classList.add('swiper-slide'));

      this.slider = new Swiper(this.target, {
        slidesPerView: 'auto',
        loop: true,
        speed: 3000,
        autoplay: {
          delay: 0,
          disableOnInteraction: false,
          pauseOnMouseEnter: true
        }
      })
    }
  }

  customElements.define('instagram-slider', InstagramSlider);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart-footer"]) return;
  try {
    
  class CartNote extends HTMLElement {
    constructor() {
      super();

      this.addEventListener('change', debounce((event) => {
        const body = JSON.stringify({ note: event.target.value });
        fetch(`${routes.cart_update_url}`, {...fetchConfig(), ...{ body }});
      }, 300))
    }
  }

  customElements.define('cart-note', CartNote);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product-starter-kit"]) return;
  try {
    
  class ProductModal extends ModalDialog {
    constructor() {
      super();
    }

    hide() {
      super.hide();
    }

    show(opener) {
      super.show(opener);
      this.showActiveMedia();
    }

    showActiveMedia() {
      this.querySelectorAll(`[data-media-id]:not([data-media-id="${this.openedBy.getAttribute('data-media-id')}"])`).forEach((element) => {
        element.classList.remove('active');
      });
      const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute('data-media-id')}"]`);
      const activeMediaTemplate = activeMedia.querySelector('template');
      const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
      activeMedia.classList.add('active');
      activeMedia.scrollIntoView();

      const container = this.querySelector('[role="document"]');
      container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

      if (activeMedia.nodeName == 'DEFERRED-MEDIA' && activeMediaContent && activeMediaContent.querySelector('.js-youtube'))
        activeMedia.loadContent();
    }
  }

  customElements.define('product-modal', ProductModal);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product-v2"]) return;
  try {
    
  class ProductModal extends ModalDialog {
    constructor() {
      super();
    }

    hide() {
      super.hide();
    }

    show(opener) {
      super.show(opener);
      this.showActiveMedia();
    }

    showActiveMedia() {
      this.querySelectorAll(`[data-media-id]:not([data-media-id="${this.openedBy.getAttribute('data-media-id')}"])`).forEach((element) => {
        element.classList.remove('active');
      });
      const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute('data-media-id')}"]`);
      const activeMediaTemplate = activeMedia.querySelector('template');
      const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
      activeMedia.classList.add('active');
      activeMedia.scrollIntoView();

      const container = this.querySelector('[role="document"]');
      container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

      if (activeMedia.nodeName == 'DEFERRED-MEDIA' && activeMediaContent && activeMediaContent.querySelector('.js-youtube'))
        activeMedia.loadContent();
    }
  }

  customElements.define('product-modal', ProductModal);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  class ProductModal extends ModalDialog {
    constructor() {
      super();
    }

    hide() {
      super.hide();
    }

    show(opener) {
      super.show(opener);
      this.showActiveMedia();
    }

    showActiveMedia() {
      this.querySelectorAll(`[data-media-id]:not([data-media-id="${this.openedBy.getAttribute('data-media-id')}"])`).forEach((element) => {
        element.classList.remove('active');
      });
      const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute('data-media-id')}"]`);
      const activeMediaTemplate = activeMedia.querySelector('template');
      const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
      activeMedia.classList.add('active');
      activeMedia.scrollIntoView();

      const container = this.querySelector('[role="document"]');
      container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

      if (activeMedia.nodeName == 'DEFERRED-MEDIA' && activeMediaContent && activeMediaContent.querySelector('.js-youtube'))
        activeMedia.loadContent();
    }
  }

  customElements.define('product-modal', ProductModal);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        fetch(this.dataset.url)
          .then(response => response.text())
          .then(text => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('product-recommendations');
            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
            }
          })
          .catch(e => {
            console.error(e);
          });
      }

      new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["starter-kit-lp-00006"]) return;
  try {
    
  class ProductModal extends ModalDialog {
    constructor() {
      super();
    }

    hide() {
      super.hide();
    }

    show(opener) {
      super.show(opener);
      this.showActiveMedia();
    }

    showActiveMedia() {
      this.querySelectorAll(`[data-media-id]:not([data-media-id="${this.openedBy.getAttribute("data-media-id")}"])`).forEach((element) => {
          element.classList.remove('active');
        }
      )
      const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);
      const activeMediaTemplate = activeMedia.querySelector('template');
      const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
      activeMedia.classList.add('active');
      activeMedia.scrollIntoView();

      const container = this.querySelector('[role="document"]');
      container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

      if (activeMedia.nodeName == 'DEFERRED-MEDIA' && activeMediaContent && activeMediaContent.querySelector('.js-youtube'))
        activeMedia.loadContent();
    }
  }

  customElements.define('product-modal', ProductModal);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["starter-kit"]) return;
  try {
    
  class ProductModal extends ModalDialog {
    constructor() {
      super();
    }
    hide() {
      super.hide();
    }
    show(opener) {
      super.show(opener);
      this.showActiveMedia();
    }
    showActiveMedia() {
      this.querySelectorAll(`[data-media-id]:not([data-media-id="${
        this.openedBy.getAttribute("data-media-id")
      }"])`).forEach((element) => {
        element.classList.remove('active');
      })
      const activeMedia = this.querySelector(`[data-media-id="${
        this.openedBy.getAttribute("data-media-id")
      }"]`);
      const activeMediaTemplate = activeMedia.querySelector('template');
      const activeMediaContent = activeMediaTemplate
        ? activeMediaTemplate.content
        : null;
      activeMedia.classList.add('active');
      activeMedia.scrollIntoView();
      const container = this.querySelector('[role="document"]');
      container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;
      if (activeMedia.nodeName == 'DEFERRED-MEDIA' && activeMediaContent && activeMediaContent.querySelector('.js-youtube'))
        activeMedia.loadContent();
    }
  }
  customElements.define('product-modal', ProductModal);

  } catch(e) { console.error(e); }
})();
})();
